import { JSX } from 'react'

import { IconProps } from '../../icon'

const Update: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M25 8C20.3723 8 16.0893 9.98564 13.1026 13.3169V9.23077C13.1026 8.55795 12.5446 8 11.8718 8C11.199 8 10.6411 8.55795 10.6411 9.23077V17.4359C10.6411 18.1087 11.199 18.6667 11.8718 18.6667H20.077C20.7498 18.6667 21.3077 18.1087 21.3077 17.4359C21.3077 16.7631 20.7498 16.2051 20.077 16.2051H13.9231C16.4339 12.6277 20.5364 10.4615 25 10.4615C32.4667 10.4615 38.5385 16.5333 38.5385 24C38.5385 24.6728 39.0964 25.2308 39.7693 25.2308C40.4421 25.2308 41 24.6728 41 24C41 15.1713 33.8287 8 25 8Z'
      fill='black'
    />
    <path
      d='M38.1282 29.3333H29.9231C29.2503 29.3333 28.6923 29.8913 28.6923 30.5641C28.6923 31.2369 29.2503 31.7949 29.9231 31.7949H36.0769C33.5662 35.3723 29.4636 37.5385 25 37.5385C17.5333 37.5385 11.4615 31.4667 11.4615 24C11.4615 23.3272 10.9036 22.7692 10.2308 22.7692C9.55795 22.7692 9 23.3272 9 24C9 32.8287 16.1713 40 25 40C29.6277 40 33.9108 38.0144 36.8974 34.6831V38.7692C36.8974 39.442 37.4554 40 38.1282 40C38.801 40 39.359 39.442 39.359 38.7692V30.5641C39.359 29.8913 38.801 29.3333 38.1282 29.3333Z'
      fill='black'
    />
  </svg>
)

export default Update
